import { Ng2StateDeclaration } from '@uirouter/angular';
import {
    paginationUrlQueryParamsDeclarations,
} from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import {
    paginationUrlQueryParamsValidator,
} from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import {
    AdminUsersComponent,
} from '@client/app/feature-modules/admin/modules/admin-users/components/admin-users/admin-users.component';
import { AdminUserFormComponent } from '../components/admin-user-form/admin-user-form.component';

export const AdminUsersStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.users',
        url: '/users?page_size&page&search&sort_by&sort_dir',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
            search: {
                dynamic: true,
                value: '',
            },
            sort_by: {
                dynamic: true,
                value: 'first_name',
            },
            sort_dir: {
                dynamic: true,
                value: 'asc',
            },
        },
        data: {
            title: 'Acquia Web Governance - User List',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/admin/users',
        },
        redirectTo: paginationUrlQueryParamsValidator('base.customer.admin.users'),
        component: AdminUsersComponent,
    },
    {
        name: 'base.customer.admin.add-user',
        url: '/user-form',
        component: AdminUserFormComponent,
        data: {
            title: 'Acquia Web Governance - Add User',
            shellPath: '/admin/user-form',
        },
    },
    {
        name: 'base.customer.admin.edit-user',
        url: '/user-form/:id',
        component: AdminUserFormComponent,
        data: {
            title: 'Acquia Web Governance - Edit User',
            shellPath: '/admin/user-form/:id',
        },
    },
];
